import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Tabs } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import LicenceParties_list from './LicenceParties_list';
import PartyCreation_Tabs from '../components/PartyCreation_Tabs';



var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}
const { TabPane } = Tabs;


var token= ''
var bizuserid= ''


class PartiesTab extends React.Component {
  state = {
    datarequested:true,
    licence_person_attachment:[],
    licence_company_attachment:[]

  };

  componentDidMount(){
    this.comp_reloaded()
    
}

comp_reloaded=()=>{

  if(localStorage.getItem("token")){
     token= localStorage.getItem("token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  this.setState({datarequested:false})


  axios.get(serverconfig.backendserverurl+`/api/licence_person_attachment/?licence=${this.props.licence_id}`)
  .then(res => {
      this.setState({
        licence_person_attachment:res.data
      })

    //  this.setState({datarequested:false})

  })


  axios.get(serverconfig.backendserverurl+`/api/licence_company_attachment/?licence=${this.props.licence_id}`)
  .then(res => {
      this.setState({
        licence_company_attachment:res.data
      })

      this.setState({datarequested:false})

  })

}




  render() {
    

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>      
         </div>
      )

    }else{
      return(
        <div>

          <Tabs
            defaultActiveKey="1"
            onChange={() => {}}
            tabPosition={'top'}
          >
             <TabPane tab={"Parties ( "+ (this.state.licence_person_attachment.length+this.state.licence_company_attachment.length)+" )"} key="1">

                <LicenceParties_list
                  licence_id={this.props.licence_id}
                />
           
             </TabPane>
             

             <TabPane tab="Party Attachment Form" key="2">
              <PartyCreation_Tabs
               licence_id={this.props.licence_id}
              />
              

             </TabPane>
             
             </Tabs>
        </div>
    )

    }

   
  }
}

export default PartiesTab; 
